/**
 * Exercise Library Data
 * 
 * Contains exercise categories and individual exercises.
 * In production, videos would be hosted on YouTube or Vimeo.
 */

export const exerciseCategories = [
  { id: 'all', name: 'All' },
  { id: 'joint-mobility', name: 'Joint Mobility Exercises' },
  { id: 'strength', name: 'Strength Exercises' },
  { id: 'stretching', name: 'Stretching' },
]

export const exercises = [
  {
    id: 1,
    title: 'Cervical CARs (Controlled Articular Rotations)',
    category: 'joint-mobility',
    description: 'Full range of motion circles for the neck to maintain joint health.',
    thumbnail: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=600&auto=format&fit=crop',
    videoUrl: '#',
    duration: '2 min',
  },
  {
    id: 2,
    title: 'Hip CARs',
    category: 'joint-mobility',
    description: 'Controlled circular movements to improve hip mobility and joint health.',
    thumbnail: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?q=80&w=600&auto=format&fit=crop',
    videoUrl: '#',
    duration: '3 min',
  },
  {
    id: 3,
    title: 'Shoulder CARs',
    category: 'joint-mobility',
    description: 'Full shoulder circumduction to maintain range of motion and joint health.',
    thumbnail: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?q=80&w=600&auto=format&fit=crop',
    videoUrl: '#',
    duration: '2 min',
  },
  {
    id: 4,
    title: '90/90 Hip Mobility',
    category: 'joint-mobility',
    description: 'A seated hip mobility exercise targeting internal and external rotation.',
    thumbnail: 'https://images.unsplash.com/photo-1552196563-55cd4e45efb3?q=80&w=600&auto=format&fit=crop',
    videoUrl: '#',
    duration: '4 min',
  },
  {
    id: 5,
    title: 'Thoracic Spine Rotation',
    category: 'joint-mobility',
    description: 'Improve mid-back mobility with this rotational exercise.',
    thumbnail: 'https://images.unsplash.com/photo-1574680096145-d05b474e2155?q=80&w=600&auto=format&fit=crop',
    videoUrl: '#',
    duration: '3 min',
  },
  {
    id: 6,
    title: 'Ankle CARs',
    category: 'joint-mobility',
    description: 'Controlled articular rotations for ankle joint health and mobility.',
    thumbnail: 'https://images.unsplash.com/photo-1434682881908-b43d0467b798?q=80&w=600&auto=format&fit=crop',
    videoUrl: '#',
    duration: '2 min',
  },
  {
    id: 7,
    title: 'Glute Bridge',
    category: 'strength',
    description: 'A fundamental exercise for glute activation and hip extension strength.',
    thumbnail: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?q=80&w=600&auto=format&fit=crop',
    videoUrl: '#',
    duration: '3 min',
  },
  {
    id: 8,
    title: 'Bird Dog',
    category: 'strength',
    description: 'Core stability exercise focusing on anti-rotation and spinal control.',
    thumbnail: 'https://images.unsplash.com/photo-1518459031867-a89b944bffe4?q=80&w=600&auto=format&fit=crop',
    videoUrl: '#',
    duration: '3 min',
  },
  {
    id: 9,
    title: 'Hip Flexor Stretch',
    category: 'stretching',
    description: 'Release tension in the hip flexors from prolonged sitting.',
    thumbnail: 'https://images.unsplash.com/photo-1575052814086-f385e2e2ad1b?q=80&w=600&auto=format&fit=crop',
    videoUrl: '#',
    duration: '2 min',
  },
  {
    id: 10,
    title: 'Pec Doorway Stretch',
    category: 'stretching',
    description: 'Open up the chest and shoulders with this simple doorway stretch.',
    thumbnail: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?q=80&w=600&auto=format&fit=crop',
    videoUrl: '#',
    duration: '2 min',
  },
]

export default exercises
